import { isClientError } from '@rr-crm/shared/api-errors';
import { QueryClient } from '@tanstack/react-query';

/**
 * QA 2026-10-01 F-33: how the CRM retries failed reads.
 *
 * TanStack Query's default is three retries with exponential backoff for
 * every error. A missing account (404) therefore showed "Loading..." for
 * six to nine seconds before "not found", and a 403 waited just as long to
 * say "no access". A 4xx is the server's answer, and asking again gets the
 * same answer, so it is never retried. A network failure or a 5xx may be
 * passing, so it gets a small retry.
 */
export const MAX_QUERY_RETRIES = 2;

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (isClientError(error)) return false;
  return failureCount < MAX_QUERY_RETRIES;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: shouldRetryQuery },
    },
  });
}
